import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'toTrustedHtml'
})
export class ToTrustedHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(input: string): SafeHtml {
    return input !== undefined ? this.sanitizer.bypassSecurityTrustHtml(input) : undefined;
  }
}
